export const DISTRIBUTION_SYSTEM_COPY = {
	title: {
		add: 'Add distribution system',
		edit: 'Edit distribution system',
	},
	submit: {
		add: 'Add',
		edit: 'Save',
	},
	description:
		'Capture the systems that store lot-to-customer data so recall notifications stay targeted.',
	fields: {
		systemLabel: 'Which system holds your distribution or lot data?',
		datasetLabel: 'What dataset or report will you export?',
	},
	actions: {
		removeConfirmTitle: 'Remove this distribution system?',
		removeConfirmDescription:
			'This system will be removed from the recall plan. You can add it again later.',
	},
	summary: {
		datasetMissing: 'Dataset details missing.',
	},
}
